import { DealerDiscountSlideOut, useDealerDiscountSlideOut } from '@makemydeal/dr-dash-components';

import { OutOfFlowHost } from '../../../ScenarioGrid.style';
import { SellingPriceRowContent } from './SellingPriceRowContent';

export const SellingPriceRow = () => {
    const { fieldKey, isSlideOutOpen, toggleSlideOut } = useDealerDiscountSlideOut();

    return (
        <>
            <SellingPriceRowContent key={fieldKey} onDiscountActivate={toggleSlideOut} />
            {isSlideOutOpen && (
                <OutOfFlowHost>
                    <DealerDiscountSlideOut show={isSlideOutOpen} onHide={toggleSlideOut} />
                </OutOfFlowHost>
            )}
        </>
    );
};
